import React from "react";
import IndiaBoatsTopBar from "../Components/IndiaBoatsTopBar";
import PremiumNavbar from "../Components/PremiumNavbar";
import {
  Users,
  PartyPopper,
  Shield,
  Sparkles,
  Sunset,
  Cake,
  Wind,
  Gift,
} from "lucide-react";
import { Camera, Heart, ShipWheel, Music, Waves } from "lucide-react";
import Footer from "../Components/Footer";
import FAQSection from "../Components/FAQSection";
import SEO from "../Components/SEO";
import { SEO_DATA } from "../config/seoData";

const familyFaq = [
  {
    question: "What is a family yacht party in Mumbai like?",
    answer:
      "A family yacht party in Mumbai is a private on-water experience where families and close groups spend quality time together in a scenic and exclusive setting."
  },
  {
    question: "Is a private yacht party suitable for family groups?",
    answer:
      "Yes. A private yacht party is ideal for family gatherings, private celebrations and meaningful time with loved ones."
  },
  {
    question: "What can we do during a family yacht party?",
    answer:
      "Guests often enjoy private cruising, family time, photos, music, sunset views and celebration moments with their group."
  },
  {
    question: "Which yacht should I choose for up to 15 guests?",
    answer:
      "For up to 15 guests, a private yacht charter is usually the best option because it feels more intimate and comfortable."
  },
  {
    question: "Which yacht should I choose for more than 15 guests?",
    answer:
      "For more than 15 guests, a yacht party format is usually more suitable because it works better for larger private groups."
  },
  {
    question: "Is this suitable for multi-generation family groups?",
    answer:
      "Yes. Family yacht parties can work very well for parents, children, grandparents and mixed-age groups."
  },
  {
    question: "How is Indiaboats different for family and private celebrations?",
    answer:
      "Indiaboats focuses on premium on-water experiences and helps guests choose the right format for smooth, scenic and memorable private outings."
  },
  {
    question: "How do I enquire about a family or private yacht party in Mumbai?",
    answer:
      "You can enquire through WhatsApp or the contact form and share your date, guest count and occasion."
  }
];

const Family = () => {
  

 const benefitsList = [
  "Premium family yacht experience in Mumbai",
  "Ideal for private and family celebrations",
  "Suitable for intimate groups and larger gatherings",
  "Beautiful sea views and private atmosphere",
  "More exclusive than ordinary venues",
  "Guidance on choosing the right yacht option",
  "Smooth and experience-led planning",
];

  const outcomes = [
  {
    text: "Private Family Time",
    description:
      "Enjoy private family time on the water in a peaceful and exclusive setting.",
    icon: <Users size={20} />,
  },
  {
    text: "Celebrate with Loved Ones",
    description:
      "Celebrate a special occasion with your family and loved ones aboard a private yacht.",
    icon: <Heart size={20} />,
  },
  {
    text: "Escape Crowded Venues",
    description:
      "Spend quality time away from busy restaurants and crowded celebration venues.",
    icon: <Shield size={20} />,
  },
  {
    text: "Capture Beautiful Memories",
    description:
      "Take beautiful group and family photos with the sea and Mumbai skyline as your backdrop.",
    icon: <Camera size={20} />,
  },
  {
    text: "Music & Celebration",
    description:
      "Enjoy your favorite music and create light, joyful celebration moments onboard.",
    icon: <Music size={20} />,
  },
  {
    text: "Peaceful Private Cruise",
    description:
      "Plan a relaxing private cruise with your close family or invited guests.",
    icon: <ShipWheel size={20} />,
  },
  {
    text: "Family Reunions & Gatherings",
    description:
      "Host a family reunion or intimate private event in a unique on-water setting.",
    icon: <PartyPopper size={20} />,
  },
  {
    text: "Sunset & Skyline Views",
    description:
      "Watch the sunset while enjoying breathtaking views of the Mumbai skyline.",
    icon: <Sunset size={20} />,
  },
  {
    text: "Premium Private Experience",
    description:
      "Create a premium private gathering on the water that feels truly memorable.",
    icon: <Sparkles size={20} />,
  },
];

  return (
    <div>
      <SEO {...SEO_DATA.familyPrivateYachtParty} />
      <IndiaBoatsTopBar />
      <PremiumNavbar />

       <section className="clsm-mid-root-wrapper">
      
      <div className="clsm-mid-bg-image" style={{backgroundImage: "url('/assets/img/family1.png')" }}></div>
      
     
      <div className="clsm-mid-bg-gradient-overlay"></div>

      <div className="clsm-mid-container">
        
        {}
        <div className="clsm-mid-header">
         <div className="csrh-centered-header">
            <h1 className="csrh-hero-title">
              A Private Yacht Celebration with the People  <br />
              <span className="csrh-title-italic">
                 Who Matter Most
              </span>
            </h1>
           
          </div>
          <div className="clsm-mid-decorative-line"></div>
        </div>

        {}
        <div className="clsm-mid-editorial-grid">
          {/* Left Column Paragraph */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
              A family or private yacht party in Mumbai offers a beautiful way to spend meaningful time with your loved ones in a more exclusive and memorable setting. Instead of a crowded venue or an ordinary outing, a private yacht gives you your own celebration space on the water with sea views, comfort and privacy.
            </p>
          </div>

          {/* Right Column Paragraphs */}
          <div className="clsm-mid-grid-col">
            <p className="clsm-mid-paragraph">
               Whether you are planning family time, a private gathering, a reunion, a quiet celebration or simply a special outing with close people, a yacht creates a setting that feels more personal and more enjoyable. The experience is not only about being on a boat — it is about sharing moments together in a scenic and premium environment.
            </p>
            <p className="clsm-mid-paragraph">
              With Indiaboats, family and private yacht parties in Mumbai feel smoother, more comfortable and more thoughtfully planned.
            </p>
          </div>
        </div>

        {}
        <div className="clsm-mid-footer">
          <div className="clsm-mid-highlight-badge">
            {/* Highly customized premium dynamic wave-and-breeze sailing wind icon */}
            <svg 
              className="clsm-mid-badge-icon" 
              viewBox="0 0 24 24" 
              fill="none" 
              stroke="currentColor" 
              strokeWidth="2.5" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            >
              <path d="M2 10h12a4 4 0 0 1 0 8H12" />
              <path d="M20 10a4 4 0 0 0-4-4H4" />
              <path d="M5 14h14a3 3 0 0 0 0-6H14" />
            </svg>
            <span className="clsm-mid-badge-text">
              No crowds. No noise. Just your people and the sea.
            </span>
          </div>
        </div>

      </div>

      </section>

       <section className="ycf-premium-wrapper">
      <div className="ycf-premium-container">
        
        {}
        <div className="ycf-premium-header">
          <h2 className="rse-section-title">
          Why a Family or Private Yacht  {" "}
        <span className="rse-serif-italic">
          Party Feels So Different
        </span>
      </h2>
          <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>
          
          <div className="ycf-premium-intro-split">
            <p className="ycf-intro-lead">
              A private yacht party feels special because it gives your group time and space away from the noise of conventional venues. There are no crowded banquet rooms, no public interruptions and no ordinary surroundings. Instead, there is open water, fresh air, privacy and a slower, more meaningful atmosphere.
            </p>
            <p className="ycf-intro-sub">
             For families, it becomes a way to enjoy quality time together. For private groups, it becomes a celebration that feels more exclusive and better suited to personal moments. The sea naturally adds calm, beauty and a sense of occasion that makes the entire experience stand out.
            </p>
          </div>
        </div>

        {}
        <div className="ycf-staggered-grid">
          
          {/* Card 1: More Private */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" strokeDasharray="3 3" />
                <circle cx="12" cy="12" r="4" fill="#ffffff" fillOpacity="0.2" />
                <path d="M12 8v8M8 12h8" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Private</h3>
            <p className="ycf-card-paragraph">
              Your group gets its own space on the water without the distractions of a public venue.
            </p>
          </div>

          {/* Card 2: More Scenic */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M2 17h20M2 20h20" />
                <path d="M12 13a4 4 0 1 0 0-8 4 4 0 0 0 0 8z" />
                <path d="M12 2v2M4.22 4.22l1.42 1.42M19.78 4.22l-1.42 1.42" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Relaxed</h3>
            <p className="ycf-card-paragraph">
              The open sea and quiet setting create a calm and comfortable atmosphere.
            </p>
          </div>

          {/* Card 3: More Personal */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Meaningful</h3>
            <p className="ycf-card-paragraph">
              The time spent together feels more focused and memorable.
            </p>
          </div>

          {/* Card 4: More Premium */}
          <div className="ycf-vessel-card">
            <div className="ycf-card-top-accent"></div>
            
            <div className="ycf-card-icon-box">
              <svg 
                className="ycf-card-svg" 
                viewBox="0 0 24 24" 
                fill="none" 
                stroke="#ffffff" 
                strokeWidth="1.75" 
                strokeLinecap="round" 
                strokeLinejoin="round"
              >
                <path d="M12 2L2 7l10 5 10-5-10-5z" />
                <path d="M2 17l10 5 10-5" />
                <path d="M2 12l10 5 10-5" />
              </svg>
            </div>
            
            <h3 className="ycf-card-title">More Scenic</h3>
            <p className="ycf-card-paragraph">
            Sea views and skyline moments make the experience feel more special.
            </p>
          </div>

        </div>

      </div>
    </section>

      

      <section className="rse-root-wrapper">
  <div className="rse-editorial-container">

    <div className="rse-header-block">
      <h2 className="rse-section-title">
        Things to Do During a{" "}
        <span className="rse-serif-italic">
          Family or Private Yacht Party
        </span>
      </h2>

      <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>

      <p className="rse-section-paragraph">
        A family and private yacht party in Mumbai can be relaxed, scenic and celebration-led depending on your group and the kind of outing you want.
      </p>
    </div>

    <div className="rse-outcomes-list">
      {outcomes.map((item, index) => (
        <div key={index} className="rse-outcome-list-item">
          <div className="rse-item-main-content">

            <div className="rse-icon-circle">
              {item.icon}
            </div>

            <div className="rse-text-stack">
              <h3 className="rse-item-title">{item.text}</h3>
              <p className="rse-item-desc">{item.description}</p>
            </div>

          </div>
        </div>
      ))}
    </div>

  </div>
</section>

     <section className="wefl-pre-root-wrapper">
  <div className="wefl-pre-editorial-container">
    <div className="wefl-pre-split-layout">
      {/* Left Column: Rich Editorial Copy */}
      <div className="wefl-pre-narrative-column">
        <div className="wefl-pre-header-block">
          <h2 className="wefl-pre-section-title">
            What the Experience{" "}
            <span className="wefl-pre-serif-italic">Feels Like</span>
          </h2>
         
        </div>

        <div className="wefl-pre-text-block wefl-pre-highlight-block">
          <div className="wefl-pre-accent-stripe"></div>
          <p className="wefl-pre-paragraph-lead">
            A family or private yacht party feels calm, spacious and personal. The moment your group steps onboard, the mood changes from routine to memorable. The setting feels open and refreshing, and the time spent together feels more focused and more enjoyable because your group has its own private environment.
          </p>
        </div>

        <div className="wefl-pre-text-block">
          <p className="wefl-pre-paragraph">
            For families, it can feel warm, comfortable and relaxed. For private groups, it can feel elegant, scenic and special. The beauty of the sea and the privacy of the yacht create an experience that feels more thoughtful than a regular outing.
          </p>
        </div>

        

        {/* Features */}
      <div className="wefl-pre-features-list">
  <div className="wefl-pre-feature-item">
    <Users size={18} className="wefl-pre-feature-icon" />
    <span>Family-Friendly Experience</span>
  </div>

  <div className="wefl-pre-feature-item">
    <PartyPopper size={18} className="wefl-pre-feature-icon" />
    <span>Private Family Celebrations</span>
  </div>

  <div className="wefl-pre-feature-item">
    <Waves size={18} className="wefl-pre-feature-icon" />
    <span>Scenic Sea Views</span>
  </div>
</div>
      </div>

      {/* Right Column */}
      <div className="wefl-pre-image-column">
        <div className="wefl-pre-image-wrapper">
          <img
            className="wefl-pre-main-image"
            src="assets/img/family4.png"
            alt="Birthday and anniversary celebration on a luxury yacht in Mumbai"
          />

          <div className="wefl-pre-floating-badge">
            <span className="wefl-pre-badge-title">Private Yacht Experience</span>
            <span className="wefl-pre-badge-subtitle">
              Celebrate on the Sea
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      <section className="csrb-root-wrapper">
      <div className="csrb-editorial-container">
        
        {}
        <div className="csrb-split-layout">
          
          {/* Left Column: Narrative Copy */}
          <div className="csrb-narrative-column">
            <h2 className="csrb-section-title">
              Why Celebrate with  <span className="csrb-serif-italic">Indiaboats</span>
            </h2>
            
            <p className="csrb-lead-paragraph">
              Indiaboats offers premium yacht experiences in Mumbai and helps guests create family and private yacht parties that feel smooth, scenic and genuinely memorable. We understand that private celebrations are personal, so the focus is on making the overall experience easy, comfortable and enjoyable.
            </p>

            <p className="csrb-lead-paragraph">
              From helping you understand which yacht suits your group size to guiding you toward the right format, Indiaboats makes it easier to plan private family celebrations and meaningful gatherings on the water.
            </p>
          </div>

          {/* Right Column: Premium Interactive List */}
          <div className="csrb-list-column">
            <span className="csrb-list-eyebrow">GOOD FOR</span>
            <ul className="csrb-list">
              {benefitsList.map((item, index) => (
                <li key={index} className="csrb-list-item">
                  <div className="csrb-bullet-wrapper">
                    {/* Minimalist modern checkmark icon inside a subtle geometric container */}
                    <svg 
                      className="csrb-bullet-icon" 
                      viewBox="0 0 24 24" 
                      fill="none" 
                      stroke="currentColor" 
                      strokeWidth="2.5" 
                      strokeLinecap="round" 
                      strokeLinejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12" />
                    </svg>
                  </div>
                  <span className="csrb-item-text">{item}</span>
                </li>
              ))}
            </ul>
          </div>

        </div>

      </div>
      </section>

     <section className="wyor-root-wrapper">
  <div className="wyor-container">

    <div className="wyor-header">
      <h2 className="rse-section-title">
        Which Yacht Option Is <br />{" "}
        <span className="rse-serif-italic">
          Right for Your Group
        </span>
      </h2>

      <div className="wyor-accent-wave">
        <svg viewBox="0 0 100 10" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M0 5 Q 25 0, 50 5 T 100 5"
            stroke="#113d48"
            strokeWidth="2"
            fill="none"
          />
        </svg>
      </div>

      <p className="wyor-lead-copy">
        The right yacht mainly depends on your group size and how intimate or
        spacious you want the experience to feel.
      </p>
    </div>

    <div className="wyor-comparison-grid">

      {/* OPTION 1 */}
      <div className="wyor-card wyor-card-left">

        <div className="wyor-card-canopy wyor-canopy-left">
          <div className="wyor-badge-capsule">
            <span className="wyor-badge-pulse"></span>
            Up to 15 Guests
          </div>

          <div className="wyor-vessel-icon-box">
            <svg
              className="wyor-svg-icon"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 42C24 42 26 38 38 38C50 38 52 42 52 42L48 48H16L12 42Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M22 38L28 16L38 38"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M28 16H34L32 24H26L28 16Z"
                fill="rgba(255,255,255,0.2)"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
              <path
                d="M6 50C18 50 22 48 34 48C46 48 50 50 62 50"
                stroke="rgba(255,255,255,0.4)"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        <div className="wyor-card-body">
          <div className="wyor-keel-line"></div>
          <h3 className="wyor-card-title">Private Yacht Charter</h3>
          <div className="wyor-divider-line"></div>

          <p className="wyor-card-paragraph">
            If your family or private yacht party is for up to 15 guests, a
            Private Yacht Charter is usually the best option. It is ideal for
            close families, intimate gatherings and smaller private
            celebrations.
          </p>
        </div>
      </div>

      {/* OPTION 2 */}
      <div className="wyor-card wyor-card-right">

        <div className="wyor-card-canopy wyor-canopy-right">
          <div className="wyor-badge-capsule">
            <span className="wyor-badge-pulse"></span>
            More than 15 Guests
          </div>

          <div className="wyor-vessel-icon-box">
            <svg
              className="wyor-svg-icon"
              viewBox="0 0 64 64"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M8 42C20 42 24 36 36 36C48 36 52 42 56 42L52 50H12L8 42Z"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M16 36V28H46V36"
                stroke="#ffffff"
                strokeWidth="2"
                strokeLinejoin="round"
              />
              <path
                d="M24 28V22H40V28"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeLinejoin="round"
              />
              <circle cx="32" cy="25" r="1.5" fill="#ffffff" />
              <circle
                cx="24"
                cy="32"
                r="2"
                fill="rgba(255,255,255,0.3)"
                stroke="#ffffff"
                strokeWidth="1"
              />
              <circle
                cx="32"
                cy="32"
                r="2"
                fill="rgba(255,255,255,0.3)"
                stroke="#ffffff"
                strokeWidth="1"
              />
              <circle
                cx="40"
                cy="32"
                r="2"
                fill="rgba(255,255,255,0.3)"
                stroke="#ffffff"
                strokeWidth="1"
              />
              <path
                d="M6 52C18 52 22 50 34 50C46 50 50 52 62 52"
                stroke="rgba(255,255,255,0.4)"
                strokeWidth="1.5"
                strokeLinecap="round"
              />
            </svg>
          </div>
        </div>

        <div className="wyor-card-body">
          <div className="wyor-keel-line"></div>
          <h3 className="wyor-card-title">Yacht Party Format</h3>
          <div className="wyor-divider-line"></div>

          <p className="wyor-card-paragraph">
            If your group is more than 15 guests, a Yacht Party format is
            usually more suitable. Larger yachts offer better space and
            movement for bigger private gatherings and family events.
          </p>
        </div>
      </div>

    </div>
  </div>
</section>

      <section className="pfUniqueMainSection" id="birtday_perfect_for">
  <div className="pfUniqueContainer">
    
    {/* Section Header */}
    <div className="pfUniqueHeader" style={{ marginBottom: "2rem" }}>
      <h2 className="pfUniqueHeading">
        Perfect For
      </h2>
    </div>

    {/* Main Content Grid */}
    <div className="pfUniqueGridWrapper">
      {[
        "Family yacht party in Mumbai",
        "Private yacht celebration with loved ones",
        "Family reunion on a yacht",
        "Small private group gatherings",
        "Premium private sea outings",
        "Multi-generation family occasions",
      ].map((item, index) => (
        <div className="pfUniqueCardBox" key={index}>
          <div className="pfUniqueCheckIcon">✓</div>
          <p className="pfUniqueCardText">{item}</p>
        </div>
      ))}
    </div>
  </div>
</section>

<div className="pyc-wrapper">
     <div className="pyc-container">
        
        {/* Main Section Header */}
        <div className="pyc-header">
         
          <h2 className="rse-section-title">
        Tailored Party {" "}
        <span className="rse-serif-italic">
          Yacht Experiences
        </span>
      </h2>
          
          <div className="ycf-premium-divider">
            <svg className="ycf-wave-svg" viewBox="0 0 100 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 6 Q 25 0, 50 6 T 100 6" stroke="#113d48" strokeWidth="2.5" fill="none" />
            </svg>
          </div>
        </div>

        {}
        <div className="pyc-unified-box">
          
          {/* Left Side: Up to 15 Guests */}
          <section className="pyc-column">
            {/* Soft backdrop image (4% opacity, shifts on hover) */}
            <div 
              className="pyc-column-bg" 
              style={{ backgroundImage: 'url("assets/img/family2.png")' }}
            />
            
            <div>
              <div className="pyc-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                  <circle cx="9" cy="7" r="4" />
                  <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                  <path d="M16 3.13a4 4 0 0 1 0 7.75" />
                </svg>
              </div>
              <div>
                <span className="pyc-card-badge">Intimate Gatherings</span>
                <h3 className="pyc-card-title">Private Yacht Party for Up to 15 Guests</h3>
                <p className="pyc-card-copy">
                  For smaller family gatherings and intimate private celebrations, a private yacht charter is usually the best choice. It offers a quieter, more personal and more comfortable environment for meaningful time together.
                </p>
              </div>
            </div>
            
            <a href="private-yacht-charter-mumbai-goa" className="pyc-cta" aria-label="Explore Private Yacht Charters for Up to 15 Guests">
              <span className="pyc-cta-text">
                Explore Private Yacht Charters for Up to 15 Guests
              </span>
              <svg className="pyc-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </section>

          {/* Elegant Dividing Line */}
          <div className="pyc-vertical-divider"></div>

          {/* Right Side: More Than 15 Guests */}
          <section className="pyc-column">
            {/* Soft backdrop image (4% opacity, shifts on hover) */}
            <div 
              className="pyc-column-bg" 
              style={{ backgroundImage: 'url("assets/img/family1.png")' }}
            />
            
            <div>
              <div className="pyc-icon-container">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z" />
                  <line x1="4" y1="22" x2="4" y2="15" />
                </svg>
              </div>
              <div>
                <span className="pyc-card-badge">Grand Events</span>
                <h3 className="pyc-card-title">Private Yacht Party for More Than 15 Guests</h3>
                <p className="pyc-card-copy">
                 For larger family occasions and bigger private groups, a yacht party format offers more guest space and a better setup for a comfortable and memorable group celebration on the water.
                </p>
              </div>
            </div>
            
            <a href="yacht-party-mumbai" className="pyc-cta" aria-label="Explore Private Yacht Parties for More Than 15 Guests">
              <span className="pyc-cta-text">Explore Yacht Parties for More Than 15 Guests</span>
              <svg className="pyc-arrow-icon" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round">
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </section>

        </div>
      </div>
</div>

       <section className="wtei-section">
      <div className="wtei-container">
        <div className="wtei-grid">
          
          {/* Left Column: Title and Narrative Copy */}
          <div className="wtei-col-left">
             <h2 className="rse-section-title">
        What to Expect {" "}
        <span className="rse-serif-italic">
         with Indiaboats
        </span>
      </h2>
            <p className="wtei-paragraph">
              When you plan a family or private yacht party with Indiaboats, the experience is designed to feel premium, comfortable and simple to organise. We help you understand which yacht format suits your group size, what type of experience works best for your occasion and how to make the outing feel special from start to finish.
            </p>
          
          </div>

          { }
          {/* Right Column: Inclusions Style List */}
          <div className="wtei-col-right">
          <ul className="wtei-list">
  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Premium private yacht experience
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Guidance based on group size and occasion
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Suitable options for intimate and larger groups
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Scenic sea views and private atmosphere
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      More meaningful alternative to ordinary venues
    </span>
  </li>

  <li className="wtei-list-item">
    <span className="wtei-list-icon">
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className="wtei-check-svg">
        <polyline points="20 6 9 17 4 12"></polyline>
      </svg>
    </span>
    <span className="wtei-list-text">
      Supportive and experience-led planning
    </span>
  </li>
</ul>
          </div>

        </div>
      </div>
      </section>

        <section className="scUniqueMainSection">
      <div className="scUniqueContainer">
        <div className="scUniqueContentBox">
          <span className="scUniqueMiniTitle">
            SAFETY & COMFORT
          </span>

          <h2 className="scUniqueHeading">
            Safety, Comfort and  <span>Guest Experience</span>
          </h2>

          <p className="scUniqueParagraph">
          At Indiaboats, safety is central to every family and private yacht party. We place strong emphasis on trained crew, responsible operations, guest comfort and smooth coordination so your celebration feels enjoyable, private and professionally managed.
          </p>
        </div>
      </div>
    </section> 

     <FAQSection
  pageKey="family-private-yacht-party-mumbai"
  title="Frequently Asked Questions About Family & Private Yacht Party Experiences"
  faqData={familyFaq}
/>
     
             <section className="btfUniqueSection" id='corporate_e_form'>
      <div className="btfUniqueContainer">

        <div className="btfUniqueFormCard">

          <div className="btfUniqueTopContent">
            <h2 className="btfUniqueHeading">
              Tell Us About Your
              <span> Celebration</span>
            </h2>

            <p className="btfUniqueParagraph">
              Share your preferred destination, group size and travel
              requirement and our team will help you plan the right
              private boat experience.
            </p>
          </div>

          <form className="btfUniqueFormWrapper">
  <div className="btfUniqueInputGrid">
    
    <div className="btfUniqueFieldBox">
      <label>Name</label>
      <input type="text" placeholder="Enter your name" />
    </div>

    

    <div className="btfUniqueFieldBox">
      <label>Mobile Number</label>
      <input type="tel" placeholder="Enter mobile number" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Email Address</label>
      <input type="email" placeholder="Enter email address" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Preferred Date</label>
      <input type="date" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Number of Guests</label>
      <input type="number" placeholder="Number of guests" />
    </div>

    <div className="btfUniqueFieldBox">
      <label>Occasion</label>
      <select>
      <option>Select celebration type</option>
<option>Birthday Celebration</option>
<option>Anniversary Celebration</option>
<option>Milestone Birthday</option>
<option>Family Celebration</option>
<option>Couple Celebration</option>
<option>Private Group Celebration</option> 
<option>Surprise Celebration</option>
<option>Other</option>
      </select>
    </div>

  </div>

  <div className="btfUniqueFieldBox btfUniqueTextareaBox">
    <label>Requirement Details</label>
    <textarea
      rows="6"
      placeholder="Tell us more about your corporate event requirements..."
    ></textarea>
  </div>

  <button
    type="submit"
    className="btfUniqueSubmitButton"
  >
    <span>Request a Proposal</span>
  </button>
</form>
        </div>
      </div>
    </section>

        
      <Footer />
    </div>
  );
};

export default Family;
